import { useEffect } from "react";

import * as S from "./MktLandingPageTemplate.style";
import {
  Hero,
  KnowHow,
  Portfolio,
  Mentor,
  Breakthrough,
  SellingPoint,
  Seniors,
  QaSolution,
  Curriculum,
  Responsibility,
  Recruit,
  Price,
  Life,
  Hesitation,
} from "../PMLandingPageTemplate/PMLandingPageTemplate.style";
import { sendLog } from "@/businessLogics/_common/logging";
import Portal from "@/components/atoms/Portal";
import MktLandingPageOrientationModalOrganism from "@/components/organisms/LandingPageOrganisms/MktLandingPageOrientationModalOrganism/MktLandingPageOrientationModalOrganism";

export default function MktLandingPageTemplate({
  lnb,
  hero,
  concerns,
  marketers,
  breakthrough,
  knowHow,
  portfolio,
  mentor,
  sellingPoint,
  benefits,
  solution,
  seniors,
  partners,
  curriculum,
  responsibility,
  brands,
  recruit,
  price,
  life,
  footer,
  // floatingCta,
}) {
  useEffect(() => {
    sendLog("sw_mainPage_view", { page_name: "마케터코스" });
  }, []);

  return (
    <>
      <Portal selector={"#portal"}>
        <MktLandingPageOrientationModalOrganism />
      </Portal>
      {lnb}
      <Hero>{hero}</Hero>
      <SellingPoint course="mkt">{sellingPoint}</SellingPoint>
      <Breakthrough>{breakthrough}</Breakthrough>
      <S.Benefits>{benefits}</S.Benefits>
      <Seniors course="mkt">{seniors}</Seniors>
      <KnowHow>{knowHow}</KnowHow>
      <Portfolio>{portfolio}</Portfolio>
      <Breakthrough course="mkt">{concerns}</Breakthrough>
      <Curriculum>{curriculum}</Curriculum>
      <S.Brands>{brands}</S.Brands>
      <Mentor>{mentor}</Mentor>
      <Hesitation>{marketers}</Hesitation>
      <Recruit>{recruit}</Recruit>
      <Price>{price}</Price>
      <Responsibility>{responsibility}</Responsibility>
      <Life>{life}</Life>
      {footer}
      {/*{floatingCta}*/}
    </>
  );
}
